import React from 'react';
import { Link } from 'react-router-dom';
import { CircleCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { pricingPlans } from '../../data/mock';

const PricingSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Simple, Transparent Pricing
          </h2>
          {/* IMPROVED: Changed from #B2B4B2 to text-gray-600 for better contrast */}
          <p className="text-lg text-gray-600">
            Choose the service level that fits your needs
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {pricingPlans.map((plan) => (
            <div 
              key={plan.id}
              className={`relative rounded-2xl p-8 ${
                plan.isPopular 
                  ? 'bg-[#003594] text-white' 
                  : 'bg-white border border-gray-200'
              }`}
            >
              {/* Popular Badge - using secondary color sparingly */}
              {plan.isPopular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <span className="bg-[#FFC72C] text-[#1a1a1a] text-sm font-bold px-4 py-1 rounded-full">
                    Most Popular
                  </span>
                </div>
              )}

              {/* Plan Title */}
              <h3 className={`text-xl font-bold text-center mb-1 ${
                plan.isPopular ? 'text-white' : 'text-gray-900'
              }`}>
                {plan.title}
              </h3>
              
              {/* Plan Subtitle - Card quantity */}
              <p className={`text-sm text-center mb-4 ${
                plan.isPopular ? 'text-white/70' : 'text-gray-500'
              }`}>
                ({plan.subtitle})
              </p>

              {/* Pricing - IMPROVED: Increased weight and contrast */}
              <div className="text-center mb-2">
                <span className={`text-lg line-through mr-2 ${
                  plan.isPopular ? 'text-white/60' : 'text-gray-400'
                }`}>
                  ${plan.originalPrice}
                </span>
                <span className={`text-4xl font-extrabold ${
                  plan.isPopular ? 'text-white' : 'text-[#003594]'
                }`}>
                  ${plan.currentPrice}
                </span>
                <span className={`font-medium ${plan.isPopular ? 'text-white/80' : 'text-gray-500'}`}>
                  /card
                </span>
              </div>

              {/* Launch Special Badge - IMPROVED: Better contrast for text */}
              <div className="flex justify-center mb-4">
                <span className={`text-xs font-bold px-3 py-1 rounded-full border ${
                  plan.isPopular 
                    ? 'border-white/40 text-white bg-white/10' 
                    : 'border-[#FFC72C] text-[#996515] bg-[#FFC72C]/10'
                }`}>
                  Launch Special
                </span>
              </div>

              {/* Description - IMPROVED: Better contrast on both backgrounds */}
              <p className={`text-center text-sm mb-6 font-medium ${
                plan.isPopular ? 'text-white/90' : 'text-gray-600'
              }`}>
                {plan.description}
              </p>

              {/* Features - IMPROVED: Better contrast for feature text */}
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <CircleCheck className={`w-5 h-5 flex-shrink-0 ${
                      plan.isPopular ? 'text-white' : 'text-[#003594]'
                    }`} />
                    <span className={`text-sm font-medium ${
                      plan.isPopular ? 'text-white/90' : 'text-gray-700'
                    }`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <Link to="/new-submission">
                <Button className={`w-full py-6 font-semibold rounded-lg ${
                  plan.isPopular 
                    ? 'bg-white text-[#003594] hover:bg-gray-100' 
                    : 'bg-[#003594] text-white hover:bg-[#002554]'
                }`}>
                  Get Started
                </Button>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
